<script setup>
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer"

const props = defineProps({
    medias: Array,
})
const handleImageError = (event) => {
    const placeholder = '/images/img_placeholder_200_200.svg';

    if (event.target.src && event.target.src.includes(placeholder)) {
        return;
    }

    event.target.src = placeholder;
};

const previewImage = (clickedImageUrl) => {
    event.preventDefault()

    const allImageUrls = props.medias.map(media => media.url);
    const initialViewIndex = allImageUrls.findIndex(url => url === clickedImageUrl);

    viewerApi({
        images: allImageUrls,
        options: {
            toolbar: false,
            transition: true,
            loading: true,
            initialViewIndex: initialViewIndex,
            keyboard: true,
        }
    })
}

function isImage(data) {
    const fileExtension = data.url.split('.').pop().toLowerCase();

    return ['jpg', 'jpeg', 'png', 'webp'].includes(fileExtension);
}

function stageLabel(stage) {
    switch (stage) {
        case 'stage1':
            return 'Stage 1';
        case 'stage2':
            return 'Stage 2';
        case 'stage3':
            return 'Stage 3';
        case 'e85':
            return 'E85';
        case 'e85plus':
            return 'E85+';
        default:
            return 'Unknown Stage';
    }
}
</script>

<template>
    <div class="border rounded border-dashed p-2" v-for="(media, index) in props.medias" :key="index">
        <div class="d-flex align-items-center">
            <div class="flex-shrink-0 me-3">
                <a href="#">
                    <!--If image, preview-->
                    <div class="avatar-sm" v-if="isImage(media)">
                        <img :src="'/format-image/'+media.url+'?w=200&h=200&fit=crop&format=webp' || '/images/img_placeholder_200_200.svg'" class="rounded img-fluid" @click="previewImage(media.url)" @error="handleImageError">
                    </div>
                    <div class="avatar-sm" v-else>
                        <div class="avatar-title bg-light text-secondary rounded fs-24 shadow">
                            <i class="ri-file-text-line"></i>
                        </div>
                    </div>
                </a>
            </div>
            <div class="flex-grow-1 overflow-hidden">
                <h5 class="fs-13 mb-0">
                    <a href="#" target="_blank" class="text-body text-truncate d-block" @click="previewImage(media.url)">{{ stageLabel(media.stage) }}</a></h5>
            </div>
            <div class="flex-shrink-0 ms-2">
                <div class="d-flex gap-1">
                    <a href="#" class="btn btn-icon text-muted btn-sm fs-18 shadow-none" @click.prevent="previewImage(media.url)">
                        <i class="ri-eye-line"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
